import { PictureInPicture2Icon } from '@hakimo-ui/hakimo/ui-elements';
import { Button } from '@hakimo-ui/shared/ui-base';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { CARD_VARIANTS, HEADER_ICON_CLASS } from './sop-card-utils';

interface HeaderProps {
  title: ReactNode;
  icon?: ReactNode;
  subtitle?: string;
  titleAfter?: ReactNode;
  headerAction?: ReactNode;
  styles: (typeof CARD_VARIANTS)[keyof typeof CARD_VARIANTS];
  showRule: boolean;
  collapsible: boolean;
  pointsDown: boolean;
  label: string;
  onToggle?: () => void;
  onDetach?: () => void;
}

export function CollapsibleCardHeader(props: HeaderProps) {
  const {
    title,
    icon,
    subtitle,
    titleAfter,
    headerAction,
    styles,
    showRule,
    collapsible,
    pointsDown,
    label,
    onToggle,
    onDetach,
  } = props;

  const iconClass = clsx(
    styles.iconButton,
    HEADER_ICON_CLASS,
    styles.iconHover
  );

  return (
    <div
      className={clsx(
        'flex justify-between gap-2',
        styles.header,
        showRule && styles.headerRule
      )}
    >
      <div className={clsx('flex min-w-0 items-center', styles.titleGroup)}>
        {icon}
        <span
          className={clsx(
            'text-onlight-text-1 dark:text-ondark-text-1 whitespace-nowrap font-sans text-sm',
            styles.title
          )}
        >
          {title}
        </span>
        {subtitle && (
          <span
            className="text-onlight-text-2 dark:text-ondark-text-2 min-w-0 truncate text-xs"
            title={subtitle}
          >
            {subtitle}
          </span>
        )}
        {titleAfter}
      </div>
      <div className={clsx('flex flex-shrink-0 items-center', styles.actions)}>
        {headerAction}
        {collapsible && (
          <Button
            variant="icon"
            onClick={onToggle}
            className={iconClass}
            title={pointsDown ? `Expand ${label}` : `Collapse ${label}`}
          >
            {pointsDown ? (
              <ChevronDownIcon className="h-4 w-4" />
            ) : (
              <ChevronUpIcon className="h-4 w-4" />
            )}
          </Button>
        )}
        {onDetach && (
          <Button
            variant="icon"
            onClick={onDetach}
            className={iconClass}
            title={`Detach ${label}`}
          >
            <PictureInPicture2Icon className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}

export default CollapsibleCardHeader;
